/**
 * The menu look, in one place.
 *
 * `DropdownMenu` owns the app's menu styling, but its Radix primitive is a `role="menu"` widget that
 * moves real DOM focus between items and consumes letter keys for its own typeahead — unusable for a
 * menu anchored to the caret inside a textarea, where focus must stay on the input and the user keeps
 * typing. That surface is a listbox instead (`MentionMenu`), so the two widgets share these classes
 * rather than the component, and a menu never looks different depending on which one it is.
 *
 * Row height is deliberately absent: dropdown rows are a fixed `h-8`, mention rows may wrap to two lines.
 */

/** Popup container. Radix-specific sizing vars and side animations stay in `dropdown-menu.tsx`. */
export const MENU_SURFACE_CLASS =
  'z-50 min-w-32 overflow-x-hidden overflow-y-auto rounded-xl border border-grey-100 bg-popover p-1.5 text-popover-foreground shadow-md';

/**
 * A row inside a menu surface. Both widgets mark the active row with `data-highlighted` — Radix sets
 * it on the focused item, the listbox sets it on the option that `aria-activedescendant` points at.
 */
export const MENU_ITEM_CLASS =
  "relative flex cursor-pointer items-center gap-2 rounded-md px-2 text-sm font-normal text-grey-800 outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-highlighted:bg-grey-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";

/** Centered helper text shown in place of the list: loading, nothing matched, cap reached. */
export const MENU_NOTICE_CLASS = 'px-2 py-1.5 text-center text-xs text-muted-foreground';
